if (!customElements.get('rich-media-slideshow')) {
  const AUTOPLAY_DELAY = 5000;

  customElements.define(
    'rich-media-slideshow',
    class RichMediaSlideshow extends HTMLElement {
      constructor() {
        super();

        this.slides = this.querySelectorAll('.rich-media-slideshow__slide');
        this.autoplay = this.hasAttribute('data-autoplay');
      }

      connectedCallback() {
        this.playVideoOnFirstSlide();

        if (this.slides.length > 1) {
          this.initSlider();
          this.toggleVideoOnSlideChange();
        }
      }

      playVideoOnFirstSlide() {
        if (this.slides.length < 2) {
          const video = this.querySelector('video');

          if (video) {
            video.play()
          }
        }
      }

      initSlider() {
        this.slider = new Swiper(this.querySelector('.swiper'), {
          ...(this.autoplay ? {
            autoplay: {
              delay: AUTOPLAY_DELAY,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            },
          } : {}),
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
          },
          cssMode: false,
          slidesPerView: 1,
          loop: false,
          speed: 600,
        });
      }

      toggleVideoOnSlideChange() {
        const videos = this.querySelectorAll('video');

        if (videos.length > 0) {
          this.slider.on('slideChangeTransitionEnd', () => {
            videos.forEach((video) => video.pause());
            this.playCurrentVideo();
          });
        }
      }

      playCurrentVideo() {
        if (this.slider) {
          const currentSlide = this.slider.slides[this.slider.activeIndex];
          const currentVideo = currentSlide.querySelector('video');

          if (currentVideo) {
            currentVideo.play();
          }
        }
      }
    }
  );
}